import { Component, OnInit } from '@angular/core';
import { ApiService } from '../../api.service';
import { Entity } from '../select-list/select-list.component';
import { MyUtility } from '../../comparison';

@Component({
  selector: 'app-organism-categories',
  templateUrl: './organism-categories.component.html',
  styleUrls: ['./organism-categories.component.css']
})
export class OrganismCategoriesComponent implements OnInit {
  public title : string;
  constructor(public api : ApiService) { }

  ngOnInit() {
    if(this.selectedItem)
      this.updater();
  }

  public updater : any;

  get items(){
    return this.api.session.organisms;
  }

  get selectedItem(){
    return this.api.session.currentCriteria.organisms.selectedCategory;
  }
  set selectedItem(value){
    MyUtility.scrubChildren(value);
    console.log("selectedItem setter: " + JSON.stringify(value));
    this.api.session.currentCriteria.organisms.selectedItems = [];
    this.api.session.currentCriteria.organisms.selectedCategory = value;
    this.updater();
  }

  clearCurrent(){
    this.api.session.currentCriteria.organisms = MyUtility.deepCopy(this.api.originalCriteria.organisms);
    this.updater();
  }
}
